module.exports = __webpack_public_path__ + "static/img/25.b9e81141.png";